// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 74) return "js/NullView.js";
	if (chunkId === 786) return "js/StartView.js";
	if (chunkId === 638) return "js/SignInView.js";
	if (chunkId === 544) return "js/RegisterView.js";
	if (chunkId === 549) return "js/DashboardView.js";
	if (chunkId === 897) return "js/ForgotPasswordView.js";
	if (chunkId === 0) return "js/ChangePasswordView.js";
	if (chunkId === 486) return "js/AccountView.js";
	if (chunkId === 664) return "js/ContactView.js";
	if (chunkId === 218) return "js/TermsAndConditions.js";
	if (chunkId === 7) return "js/AcceptLegals.js";
	// return url for filenames based on template
	return undefined;
};